<template>
  <div
    class="sitebuilder-element-container"
    element="PandaVideoComponent"
    :data-hide-desktop="!this.internal_config.showDesktop"
    :data-hide-mobile="!this.internal_config.showMobile"
    :id="id"
    :config-properties="JSON.stringify(internal_config)"
    v-on:click="focusElement($event)"
    @contextmenu.prevent="handler($event)"
    :style="style()"
  >
    <vue-draggable-resizable
      v-bind:w="parseInt(internal_config.width)"
      v-bind:h="parseInt(internal_config.height)"
      @resizing="onResize" ref="draggableResizable"
      :draggable="false"
      :enable-native-drag="true"
    >
      <rotate :target="this.$refs.draggableResizable" :config="this.internal_config"/>
      <options-element-bar ref="optionsBar" :elem="this" name="ct-component-PandaVideoComponent">
        <img
          src="static/images/icons/engrenagem.svg"
          v-tooltip="{content:$t('ct-settings'),  class: 'tooltip-custom'}"
          class="svg-icon normal-action"
          @click="openModal"
        />
        <!--        <img src="static/images/icons/pin.svg"-->
        <!--             v-tooltip="{content:$t('ct-sticky'),  class: 'tooltip-custom'}"-->
        <!--             class="svg-icon normal-action hide-resource-on-mobile"-->
        <!--             @click="stickyElement"/>-->
      </options-element-bar>

      <div class="divBlock" v-show="!this.preview"></div>

      <template v-if="internal_config.videoConfigs">
        <div class="preview-img" v-if="!preview && internal_config.videoConfigs.thumbnail">
          <img
            :src="internal_config.videoConfigs.thumbnail"
            :width="internal_config.width"
            :height="internal_config.height"
            v-bind:style="{'border-radius': radius,border : border}"
          />
          <font-awesome-icon :icon="['fas', 'play']" color="#19B7EA" class="font-awesome-icon sort-icon"/>
        </div>
        <div id="the-sticky-div" class="embed-responsive embed-responsive-16by9" v-else>
          <div class="sticky-video-content">
            <div class="video">
              <iframe
                :id="internal_config.videoConfigs.id"
                :width="internal_config.width"
                :height="internal_config.height"
                :src="getUrl()"
                frameborder="0"
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
                class="embed-responsive-item"
                v-bind:style="{'border-radius': radius,border : border}"
              ></iframe>
            </div>
          </div>
        </div>
      </template>
      <div v-else>
        <div
          style="background-color: white; height: 200px; width: 100%; display: flex; align-items: center; justify-content: center; flex-direction: column">
          <h6 class="text-center">{{ $t('ct-select-video-panda') }}</h6>
        </div>
      </div>
      <resources ref="resourcesData"></resources>
    </vue-draggable-resizable>
  </div>
</template>
<script>
import Model from "./Model";
import Resources from "./Resources.vue";
import OptionsElementBar from "../OptionsElementBar";

export default {
  name: "VimeoVideoComponent",
  components: {
    OptionsElementBar,
    Model,
    Resources
  },
  props: ["config", "height_start", "device", "id", "preview"],
  data() {
    return Model.data();
  },
  watch: {
    internal_config: {
      deep: true,
      handler(value) {
        this.$eventHub.setValueElementConfig(this.id, value);
        this.$eventPointer.log(this.id, value);
      }
    }
  },

  computed: {
    width() {
      return this.internal_config.width;
    },
    height() {
      return this.internal_config.height;
    },
    border() {
      return this.internal_config.border;
    },
    radius() {
      return this.internal_config.borderRadius;
    }
  },
  methods: {
    getUrl() {
      let url = this.internal_config.videoConfigs.video_player;
      let linkTemp = document.createElement('a');
      linkTemp.href = url;
      let search = linkTemp.search !== '';

      url =  url + ((search) ? '&' : '?');

      if (this.internal_config.checkBoxAutoPlay) {
        url = url + "autoplay=true";
      }

      return url;
    },
    animation() {
      return true;
    },

    onResize: function (x, y, width, height) {
      this.internal_config.width = width + "px";
      this.internal_config.height = height + "px";

      this.$refs.resourcesData.setValuesData(this);
    },

    focusElement(e) {
      this.$root.$emit("focusElement", this);
      this.$root.$emit('handlerElement', this);

      e.stopPropagation();
      e.preventDefault();
    },

    showResources() {
      return this.$refs.resourcesData.getValuesData();
    },

    stickyElement: function () {
      this.$root.$emit('StickyElement', this);
    },

    openModal() {
      this.$root.$emit(
        'openPandaVideoModal',
        this.internal_config,
        this.build
      );
    },

    changeOrderPanel(elem, idx) {
    },

    handler: function (e) {
      this.$root.$emit("focusElement", this);
      this.$root.$emit("handlerElement", this, true);

      e.stopPropagation();
      e.preventDefault();
    },

    style() {
      let style = `left:  ${this.internal_config.left};
                     z-index: ${this.internal_config.zIndex};
                     max-width: ${this.internal_config.maxWidth};
                     margin: 0 auto;
                     padding-top: ${this.internal_config.paddingTop};
                     padding-left: ${this.internal_config.paddingLeft};
                     padding-right: ${this.internal_config.paddingRight};
                     padding-bottom: ${this.internal_config.paddingBottom};
                     top: ${this.internal_config.top}`;
      return style;
    },

    addScriptOnHead() {
      if (!document.querySelector('script[src^="https://player.pandavideo.com.br/api.v2.js"]')) {
        let s = document.createElement('script');
        s.src = 'https://player.pandavideo.com.br/api.v2.js?nowprocket&version=1665967882479';
        s.async = true;
        document.head.appendChild(s);
      }
    },

    build({videoConfigs}) {
      this.internal_config.videoConfigs = videoConfigs
      let vm = this;
      let config = this.internal_config;
      this.$nextTick(() => {
        this.internal_config = {};
        vm.internal_config = Object.assign({}, vm.internal_config, config);
      });
    }
  },
  updated() {
    if (this.preview) {
      if (this.internal_config.StickyVideo) {
        this.$root.$emit("applySticky", this,);
      }
    }
  },
  created() {
    let device, childs, id, config;
    ({device, childs, id, config} = this.$props);
    this.internal_config = config;
    this.device = device;
    if (typeof id !== "undefined") {
      this.id = id;
    }
    this.internal_config = window.mergeRecursive(
      this.props,
      this.$props.config
    );
  },
  mounted() {
    this.$refs.resourcesData.setValuesData(this);

    this.addScriptOnHead();

    if (this.$props.preview) {
      this.$root.$emit("applyAnimation", this, "sitebuilder-element-container");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/editor/apps/PandaVideo/PandaVideo.vue